import { Module } from 'vuex'
import { RootState } from 'surface/xstore/types'

enum OnboardingStages {
  Settings = 'main',
  ReadyToPost = 'ready',
}

interface OnboardingState {
  isFirstView: boolean,
  onboardingStage: OnboardingStages | null,
}

const OnboardingModule: Module<OnboardingState, RootState> = {
  namespaced: true,
  state: {
    isFirstView: false,
    onboardingStage: null,
  },
  getters: {
    isFirstView (state): boolean { return state.isFirstView },
    isWallOnboardingFlow (state): boolean { return state.onboardingStage !== null },
    xReadyToPostPanel (state): boolean { return state.onboardingStage === OnboardingStages.ReadyToPost },
  },
  mutations: {
    SET_IS_FIRST_VIEW (state, isFirstView): void {
      state.isFirstView = isFirstView
    },
    CHANGE_ONBOARDING_STAGE (state, stage: OnboardingStages): void {
      state.onboardingStage = stage
    },
    END_ONBOARDING (state): void {
      state.onboardingStage = null
    },
  },
  actions: {
    setIsFirstView ({ commit }, payload: boolean): void {
      commit('SET_IS_FIRST_VIEW', payload)
    },
    goOnboardingNextStage ({ state, commit, dispatch }): void {
      if (state.onboardingStage === OnboardingStages.Settings) {
        // This is currently called after saving is done.
        // TODO: Should we be handling confirm/saving here instead?
        dispatch('settings/hideSettingsPanel', undefined, { root: true })
        commit('CHANGE_ONBOARDING_STAGE', OnboardingStages.ReadyToPost)
      } else if (state.onboardingStage === OnboardingStages.ReadyToPost) {
        commit('END_ONBOARDING')
      }
    },
    goOnboardingPreviousStage ({ state, commit, dispatch }): void {
      if (state.onboardingStage === OnboardingStages.Settings) {
        // Currently never used because we endOnboarding manually in the component `close` method
        // TODO: This should replace the settings panel `close` method when isWallOnboardingFlow
        dispatch('settings/hideSettingsPanel', undefined, { root: true })
        commit('END_ONBOARDING')
      } else if (state.onboardingStage === OnboardingStages.ReadyToPost) {
        commit('CHANGE_ONBOARDING_STAGE', OnboardingStages.Settings)
        dispatch('settings/showSettingsPanel', undefined, { root: true })
      }
    },
    startOnboardingIfFirstView ({ commit, getters, dispatch }): void {
      if (!getters.isFirstView) return
      commit('CHANGE_ONBOARDING_STAGE', OnboardingStages.Settings)
      dispatch('settings/showSettingsPanel', undefined, { root: true })
    },
    endOnboarding ({ commit }): void {
      commit('END_ONBOARDING')
    },
  },
}

export default OnboardingModule
export {
  OnboardingState,
}
